module.exports = __webpack_public_path__ + "static/ozlem-281cb50e3445a41b6406379b5b9e59a4.png";